/** Canon Magento 8-character retail item code, e.g. 1483C010. */
export function isCanonRetailItemCode(value?: string): boolean {
  return /^[0-9]{4}[A-Z][0-9]{3}$/i.test(String(value || '').trim());
}

/**
 * Body vs kit on the same Canon PDP: SKU 1483C010 (lens kit) and
 * productId/MPN 1483C002 (body) are different simples, not SKU vs MPN.
 */
export function isSiblingCanonItemCode(sku?: string, mpn?: string): boolean {
  const a = String(sku || '').trim();
  const b = String(mpn || '').trim();
  if (!a || !b) return false;
  if (a.toUpperCase() === b.toUpperCase()) return false;
  return isCanonRetailItemCode(a) && isCanonRetailItemCode(b);
}

export function catalogIdentityLine(product: { sku?: string; mpn?: string }): string | null {
  const sku = String(product.sku || '').trim();
  const mpn = String(product.mpn || '').trim();
  if (sku && mpn && sku.toLowerCase() !== mpn.toLowerCase() && !isSiblingCanonItemCode(sku, mpn)) {
    return `SKU ${sku} · MPN ${mpn}`;
  }
  if (sku) return `SKU ${sku}`;
  if (mpn) return `MPN ${mpn}`;
  return null;
}
